import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ProcessResult } from "../types/output_vu";

interface ProcessVuState {
  results: Record<string, ProcessResult>; // key: documentId
  isLoading: boolean;
  error: string | null;
  currentTab: "전체 텍스트" | "음원 분석" | "감정 분석" | "음원 분리";
  selectedSpeaker: string | null;
  _hasHydrated: boolean; // Rehydration status

  // Actions
  setResult: (documentId: string, result: ProcessResult) => void;
  setIsLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  setCurrentTab: (
    tab: "전체 텍스트" | "음원 분석" | "감정 분석" | "음원 분리"
  ) => void;
  setSelectedSpeaker: (speaker: string | null) => void;
  reset: () => void;
  // ... (get... 함수들은 나중에 수정)
}

const initialState = {
  results: {},
  isLoading: false,
  error: null,
  currentTab: "전체 텍스트" as const,
  selectedSpeaker: null,
  _hasHydrated: false,
};

export const useProcessVuStore = create<ProcessVuState>()(
  persist(
    (set) => ({
      ...initialState,

      setResult: (documentId, result) =>
        set((state) => ({
          results: { ...state.results, [documentId]: result },
          isLoading: false,
          error: null,
        })),
      setIsLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error, isLoading: false }),
      setCurrentTab: (currentTab) => set({ currentTab }),
      setSelectedSpeaker: (selectedSpeaker) => set({ selectedSpeaker }),
      reset: () => set(initialState),

      // Computed value 함수들은 스토어의 `result`를 직접 참조하지 않도록 수정 필요
      // 이 부분은 페이지 컴포넌트에서 selector를 통해 구현하는 것이 더 적합
      getSpeakerUtterances: (speaker: string) => {
        // TODO: This needs to be adapted to use a result for a specific documentId
        return [];
      },

      getEmotionTimeline: () => {
        // TODO: This needs to be adapted to use a result for a specific documentId
        return [];
      },

      getSeparatedAudioUrls: () => {
        // TODO: This needs to be adapted to use a result for a specific documentId
        return {};
      },
    }),
    {
      name: "process-vu-result-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => !key.startsWith("_"))
        ),
      onRehydrateStorage: () => {
        setTimeout(() => {
          useProcessVuStore.setState({ _hasHydrated: true });
        }, 0);
      },
    }
  )
);
